// Carousels
var Flickity = require('flickity');

const carouselElems = document.querySelectorAll('.carousel');
const arrowShape = 'm.5 50.031 50.986 21.815 1.931-4.512-34.771-14.878H100v-4.909H18.736L53.42 32.666l-1.937-4.512z';
const svgURI = 'http://www.w3.org/2000/svg';

let carousels = [];
let carouselsWithOverlays = [];

carouselElems.forEach((elem) => {
  if (elem.classList.contains('carousel-with-overlay')) {
    carouselsWithOverlays.push(elem);
  } else {
    carousels.push(elem);
  }
})

const initCarousel = function (carousel) {
  let slider = carousel.querySelector('.carousel-slider');
  let sliderCells = carousel.querySelectorAll('.carousel-cell');
  let captions = carousel.querySelectorAll('.carousel-caption');

  if (slider) {
    carousel.flkty = new Flickity(slider, {
      pageDots: false,
      prevNextButtons: true,
      arrowShape: arrowShape,
      wrapAround: true,
      adaptiveHeight: false,
      cellAlign: 'center',
      dragThreshold: 10,
      on: {
        ready: function() {
          carousel.viewport = carousel.querySelector('.flickity-viewport');
        }
      },
    });

    // select cells when clicked directly
    // https://codepen.io/desandro/pen/OPBoWx
    carousel.flkty.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
      if ( typeof cellIndex == 'number' ) {
        carousel.flkty.selectCell( cellIndex );
      }
    });

    // Change captions when carousel slide changes
    if (captions) {
      carousel.flkty.on('change', function (index) {
        captions.forEach((caption) => caption.classList.remove('show'));
        if (captions[index]) {
          captions[index].classList.add('show');
        }
      });
    }

    sliderCells.forEach((cell, index) => {
      // When a CTA link is focused, animate to it's cell
      // and prevent the browser from scrolling the .flickity-viewport
      let cta = cell.querySelector('.carousel-overlay-cta');

      if (cta) {
        cta.addEventListener('focus', () => {
          setTimeout(() => {
            carousel.viewport.scroll(0, 0);
            carousel.flkty.select(index)
          }, 0);
        })
      }
    })

    // Mobile nav arrows
    const carouselMobileNav = carousel.querySelector('.carousel-mobile-nav')

    if (carouselMobileNav) {

      createSVG = function(direction) {
        var svg = document.createElementNS( svgURI, 'svg' );
        svg.setAttribute( 'class', 'flickity-button-icon' );
        svg.setAttribute( 'viewBox', '0 0 100 100' );
        var path = document.createElementNS( svgURI, 'path' );
        path.setAttribute( 'd', arrowShape );
        path.setAttribute( 'class', 'arrow' );
        // rotate arrow
        if ( direction == 'right' ) {
          path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
        }
        svg.appendChild( path );
        return svg;
      };

      const prevBtn = carouselMobileNav.querySelector('.previous');
      const nextBtn = carouselMobileNav.querySelector('.next');

      if (prevBtn) {
        let svg = createSVG('left');
        prevBtn.appendChild( svg );
      }

      if (nextBtn) {
        let svg = createSVG('right');
        nextBtn.appendChild( svg );
      }

      // prevent focus on mousedown or touchdown event
      prevBtn.addEventListener('pointerdown', (event) => {
        event.preventDefault();
      });

      nextBtn.addEventListener('pointerdown', (event) => {
        event.preventDefault();
      });

      // Click events
      // If the button isn't already focused, move focus to the slider
      prevBtn.addEventListener('click', (event) => {
        const parent = event.target.closest('button');

        carousel.flkty.previous();

        if (document.activeElement !== parent) {
          slider.focus();
        }
      });

      nextBtn.addEventListener('click', (event) => {
        const parent = event.target.closest('button');

        carousel.flkty.next();

        if (document.activeElement !== parent) {
          slider.focus();
        }
        });
    }
  }
}

// Normal Carousels
carousels.forEach((carousel) => {
  initCarousel(carousel);
});

// Carousels with Overlays
// Remove the carousel functionality on mobile
if (carouselsWithOverlays) {

  const carouselBreakpoint = '768px';
  const carouselMediaQuery = window.matchMedia(`(min-width: ${carouselBreakpoint})`);

  function handleCarouselMediaChange(e) {
    if (e.matches) {
      carouselsWithOverlays.forEach((carousel) => {
        initCarousel(carousel);
      });

    } else {
      carouselsWithOverlays.forEach((carousel) => {
        if (carousel.flkty) {
          carousel.flkty.destroy();
        }
      })
    }
  }

  // Register event listener
  carouselMediaQuery.addEventListener('change', handleCarouselMediaChange);

  // Initial check
  handleCarouselMediaChange(carouselMediaQuery);
}
